import { POItemFormValues } from "./config";

export const calcItemTotal = (
  quantity: number | string,
  unitPrice: number | string,
): number => Number(quantity || 0) * Number(unitPrice || 0);

export const calcOrderTotal = (items: POItemFormValues[]): number =>
  items.reduce((sum, item) => sum + calcItemTotal(item.quantity, item.unitPrice), 0);

export const formatCurrency = (value: number): string =>
  value.toLocaleString("vi-VN") + " ₫";
